module.exports = __webpack_public_path__ + "1495095f48f6aa55230fc636fde09e16.MP3";